<div class="aems-bread-crumb m-b-16">
  <a class="m-r-4" routerLink="/workorders">Work Orders</a><span>/ Create / Mutiple Equipments</span>
</div>
<app-error [httpError]="httpError()"></app-error>
<app-bulk-work-order-header></app-bulk-work-order-header>
<app-bulk-work-order-repair-line-items></app-bulk-work-order-repair-line-items>
<app-bulk-work-order-manhours
  [totalManHoursWithoutPrepTime]="totalManhoursWithoutPrepTime"
  [manHoursThatQualifyForPrepTime]="manHoursThatQualifyForPrepTime"
  [isPrepTimeApplicable]="isPrepTimeApplicable"
  [mode]="selectedMode"></app-bulk-work-order-manhours>
@if (showTotalCost) {
  <app-cwo-total-cost title="Total per equipment" [cost]="costPerWorkorder"></app-cwo-total-cost>
}
@if (errorInCalculatingTotalCost) {
  <app-error [errors]="['Labour rate not present for the shop. Cannot calculate total cost for the workorder']"></app-error>
}
<app-bulk-work-order-remark></app-bulk-work-order-remark>
<div style="text-align: right">
  @let containerGradeErrors = (bulkWorkorderSharedDataService.ContainerGradeValidationErrors | async)?.length === 0 ? false : true;
  @let containerSizeErrors = (bulkWorkorderSharedDataService.ContainerSizeValidationErrors | async)?.length === 0 ? false : true;
  @let manufacturerErrors = (bulkWorkorderSharedDataService.ManufacturerValidationErrors | async)?.length === 0 ? false : true;
  <mc-button
    data-cy="submit"
    variant="filled"
    appearance="primary"
    fit="medium"
    padding="default"
    [disabled]="
      bulkWorkorderSubmitButtonDisabled() ||
      bulkWorkorderSubmitApiCallStatus == 'IN_PROGRESS' ||
      containerGradeErrors ||
      containerSizeErrors ||
      manufacturerErrors ||
      errorInCalculatingTotalCost
    "
    [loading]="bulkWorkorderSubmitApiCallStatus == 'IN_PROGRESS'"
    (click)="onSubmitClicked()"
    (keydown)="onSubmitKeydown($event)">
    Submit
  </mc-button>
</div>
<mc-toast position="top-right" duration="6000" appearance="success" [open]="successToastOpen()" (close)="onSuccessToastClosed()">
  <mc-notification [body]="appTextSvc.BulkWorkOrderSubmittedSuccessfully"> </mc-notification>
</mc-toast>
